"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarGroup = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Avatar = require("./Avatar");
var _reactstrap = require("reactstrap");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Avatar Group
 */
var AvatarGroup = exports.AvatarGroup = /*#__PURE__*/function (_Component) {
  function AvatarGroup(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, AvatarGroup);
    _this = _callSuper(this, AvatarGroup, [props]);
    _this._toggle = _this._toggle.bind(_this);
    _this._showPlusButton = showPlusButton.bind(_this);
    _this.state = {
      dropdownOpen: false
    };
    return _this;
  }
  (0, _inherits2["default"])(AvatarGroup, _Component);
  return (0, _createClass2["default"])(AvatarGroup, [{
    key: "_toggle",
    value: function _toggle() {
      this.setState({
        dropdownOpen: !this.state.dropdownOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var users = this.props.users;
      var max = this.props.max || 0;
      if (!users) return null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "collab-avatars"
      }, renderUsers(users, max), this._showPlusButton(users, max));
    }
  }]);
}(_react.Component);
var renderUsers = function renderUsers(users, max) {
  return users.map(function (user, indx) {
    return indx < max ? /*#__PURE__*/_react["default"].createElement(_Avatar.Avatar, {
      key: "avatar-".concat(user._id),
      height: "28px",
      width: "28px",
      user: user
    }) : false;
  });
};
var showPlusButton = function showPlusButton(users, max) {
  var dropdownOpen = this.state.dropdownOpen;
  return users.length > max ? /*#__PURE__*/_react["default"].createElement(_reactstrap.Dropdown, {
    isOpen: dropdownOpen,
    toggle: this._toggle
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownToggle, {
    caret: true
  }, "+", users.length - max), /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownMenu, null, dropdownOpen && renderExtraUsers(users, max))) : null;
};
var renderExtraUsers = function renderExtraUsers(users, max) {
  return users.map(function (user, indx) {
    return indx >= max ? /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownItem, {
      className: "dd-privacy-mask",
      key: "".concat(user._id, "-menu-item-").concat(indx)
    }, /*#__PURE__*/_react["default"].createElement(_Avatar.Avatar, {
      key: "".concat(user._id, "-avatar-").concat(indx),
      height: "28px",
      width: "28px",
      user: user
    }), ' ', user.firstName, " ", user.lastName) : null;
  });
};
AvatarGroup.propTypes = {
  users: _propTypes["default"].array,
  max: _propTypes["default"].number
};